import React from 'react';
import propTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import Box from 'core/ui/Box';
import ClassDetail from 'components/Workout/Grid/Details/ClassDetail';
import { DialogContent } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { primary } from 'core/ui/Colors';

const WorkoutShow = ({
  open,
  setOpen,
  workout,
  embed,
  loading,
  confirmCancelClass,
  buttonColor,
}) => {
  return (
    <Dialog scroll="body" fullWidth maxWidth="sm" onClose={() => setOpen(false)} open={open}>
      <DialogContent>
        <Box p={1}>
          {loading ? (
            <>
              <Skeleton variant="rect" style={{ width: '100%', height: 150 }} />
              <Skeleton variant="rect" style={{ marginTop: 5, width: '100%', height: 100 }} />
            </>
          ) : (
            <ClassDetail
              setOpenDetail={setOpen}
              workoutId={workout.id}
              embed={embed}
              confirmCancelClass={confirmCancelClass}
              buttonColor={buttonColor || primary}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

WorkoutShow.propTypes = {
  loading: propTypes.bool,
  open: propTypes.bool,
  embed: propTypes.bool,
  setOpen: propTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  workout: propTypes.object.isRequired,
};

WorkoutShow.defaultProps = {
  open: false,
  loading: false,
  embed: false,
  setOpen: null,
};

export default WorkoutShow;
